import { DateCalendar } from '@mui/x-date-pickers'
import moment from 'moment'
import { useState } from 'react'
import { formatDate } from '../../helpers'
import { PopoverMenu } from './popover'
import { TextInput } from './textInput'

export const DateInput = ({
  placeholder = '',
  errors = '',
  title = '',
  date,
  minDate,
  referenceDate,
  setDate = () => {},
  onBlur,
  disabled = false,
  className = '',
  name,
  dateFormat = 'MMMM DD, YYYY',
}: {
  placeholder: string
  name: string
  errors?: string
  title: string
  date?: Date | null
  minDate?: moment.Moment
  referenceDate?: moment.Moment
  onBlur: React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>
  setDate?: (date: Date | null) => void
  disabled?: boolean
  className?: string
  dateFormat?: string
}) => {
  const [clicked, setClicked] = useState<boolean>(false)

  if (disabled) {
    return (
      <button className="h-fit w-full text-left" type="button">
        <TextInput
          type="text"
          name={name}
          value={formatDate(date, dateFormat)}
          placeholder={placeholder}
          onChange={() => {}}
          onBlur={onBlur}
          title={title}
          errors={errors}
          containerClassName=""
          readOnly
          isDropdown
          inputClass="!cursor-not-allowed bg-grey-100"
          hasIcon={false}
        />
      </button>
    )
  }
  return (
    <PopoverMenu
      customMenuItems={({ close }) => {
        return (
          <div className={className}>
            <DateCalendar
              value={
                clicked && date === null ? moment(new Date()) : moment(date)
              }
              onChange={(newDate) => {
                setDate(newDate ? newDate.toDate() : null)
                close()
              }}
              minDate={minDate}
              referenceDate={referenceDate}
              disablePast
              views={['year', 'month', 'day']}
              sx={{
                '& .MuiPickersDay-root.Mui-selected': {
                  backgroundColor: '#04000A !important',
                  color: 'white',
                },
                '& .MuiPickersMonth-monthButton.Mui-selected': {
                  backgroundColor: '#04000A !important',
                  color: 'white',
                },
                '& .MuiPickersYear-yearButton.Mui-selected': {
                  backgroundColor: '#04000A !important',
                  color: 'white',
                },
              }}
            />
          </div>
        )
      }}
      menuClassName="rounded-xl bg-white !shadow-sm border"
      className="w-full"
      position="bottom"
    >
      <button className="h-fit w-full text-left" type="button">
        <TextInput
          type="text"
          name={name}
          value={formatDate(date, dateFormat)}
          placeholder={placeholder}
          onChange={() => {}}
          onBlur={(e) => {
            setClicked(true)
            onBlur(e)
          }}
          title={title}
          errors={errors}
          containerClassName=""
          readOnly
          isDropdown
          inputClass="!cursor-pointer"
          hasIcon={false}
        />
      </button>
    </PopoverMenu>
  )
}
